/* eslint-disable consistent-return */
import { Middleware, NuxtError } from '@nuxt/types';

import apiUrls from '~/apiUrls.config.js';
import { IRouteInfo } from '~/types/IRouteInfo';

const routeAuthBlog: Middleware = async ({
  route, app, store, error,
}) => {
  try {
    const payload: IRouteInfo = await app.$http.$get(`${apiUrls.routing}/czy-jest-route?route=${route.path}`);

    store.commit('blog/routeInfo', payload);
  } catch (e) {
    const err = e as NuxtError;

    return error({ statusCode: err.statusCode });
  }
};

export default routeAuthBlog;
